import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Badge } from "./ui/badge";
import { 
  RectangleVertical,
  Layers,
  DoorOpen, 
  Droplets, 
  Scissors, 
  Shield, 
  Sun, 
  ClipboardCheck 
} from "lucide-react";

const services = [
  {
    icon: RectangleVertical,
    title: "Glass Window/Hatch Installation or Replacement",
    description: "Complete installation and replacement services for marine glass windows and hatches.",
  },
  {
    icon: Layers,
    title: "Acrylic Window/Hatch Installation or Replacement",
    description: "Expert acrylic window and hatch installation with precision fitting.",
  },
  {
    icon: DoorOpen,
    title: "Entry & Salon Doors Installation or Replacement",
    description: "Custom-made doors crafted from glass or acrylic materials.",
  },
  {
    icon: Droplets,
    title: "Leak Repairs",
    description: "Professional sealing and leak repair for windows and hatches.",
  },
  {
    icon: Scissors,
    title: "Custom Fabrication",
    description: "Pattern, template, and custom-fabricate to match exact specifications.",
  },
  {
    icon: Shield,
    title: "Resealing and Re-bedding",
    description: "Proper resealing and re-bedding services to prevent future leaks.",
  },
  {
    icon: Sun,
    title: "Marine Window Tinting and Protective 3M Filming",
    description: "Outside UV protection, glare reduction, and privacy tinting options.",
    isNew: true,
  },
  {
    icon: ClipboardCheck,
    title: "Inspection and Consultation",
    description: "Professional assessment of window and hatch condition.",
  },
];

export const Services = () => {
  return (
    <section id="services" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Our Services</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Comprehensive marine window and hatch solutions
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card 
                key={index} 
                className="group relative hover:shadow-2xl hover:shadow-azure-500/10 hover:-translate-y-2 transition-all duration-300 cursor-pointer border-border/50 hover:border-azure-500/30"
              >
                {service.isNew && (
                  <Badge className="absolute top-4 right-4 bg-navy-900 text-white z-10 transition-transform group-hover:scale-110">
                    NEW
                  </Badge>
                )}
                <CardHeader>
                  <div className="mb-4 relative">
                    <div className="w-16 h-16 rounded-full bg-azure-500/10 flex items-center justify-center transition-all duration-500 group-hover:bg-azure-500/20 group-hover:shadow-lg group-hover:shadow-azure-500/20 group-hover:scale-110">
                      <Icon className="h-8 w-8 text-azure-500 transition-all duration-500 group-hover:text-azure-hover group-hover:rotate-12 group-hover:scale-110" />
                    </div>
                  </div>
                  <CardTitle className="text-lg group-hover:text-azure-500 transition-colors duration-300">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-sm transition-colors duration-300 group-hover:text-foreground/80">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
